import { apiClient, createSuccessResponse, handleApiError } from "./api";

const configurationService = {

    async editConfiguration(id) {
        try {

            console.log(id)

            var retorno = await apiClient.get("/configuration/" + id);
            console.log(retorno.data)
            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

    async update(configuration) {
        try {
            console.log(configuration)

            var retorno = await apiClient.put("/configuration", configuration);

            return createSuccessResponse(retorno.data, retorno.status, retorno.message);
        } catch (error) {
            const processedError = handleApiError(error);
            return {
                success: false,
                message: processedError.message,
                status: processedError.status,
                error: processedError.error,
                code: processedError.code,
                details: processedError.details
            }
        }
    },

}

export default configurationService;